import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { CashDesksByCity } from "./cash-desk.model";

const ACTION_PREFIX = "[Cash Desk]";
export const CASH_DESK_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,
};

@Injectable({
	providedIn: "root",
})
export class CashDeskAction {
	get(): Action {
		return createCachedGetAction({
			type: CASH_DESK_ACTION_TYPE.get,
		});
	}

	getSuccess(payload: CashDesksByCity): ActionWithPayload {
		return createGetSuccessAction({
			type: CASH_DESK_ACTION_TYPE.getSuccess,
			payload,
		});
	}

	getFail(error: AppError): ActionWithPayload {
		return {
			type: CASH_DESK_ACTION_TYPE.getFail,
			payload: error,
		};
	}
}
